// @flow

import { useRef, useLayoutEffect, useCallback } from 'react';

import { createTextMaskInputElement } from 'text-mask-core';
import { type Mask } from './types';

type InputRef = {|
  current: ?HTMLInputElement,
|};

export function useInputMask(
  inputRef: InputRef,
  mask: Mask,
  value: ?string,
): () => any {
  const textMaskHandleRef = useRef(null);

  useLayoutEffect(
    () => {
      if (!inputRef.current) {
        return;
      }

      textMaskHandleRef.current = createTextMaskInputElement({
        inputElement: inputRef.current,
        mask,
        guide: false,
      });
    },
    [inputRef, mask, textMaskHandleRef],
  );

  useLayoutEffect(
    () => {
      textMaskHandleRef.current && textMaskHandleRef.current.update(value);
    },
    [mask, textMaskHandleRef, value],
  );

  const updateValueForMask = useCallback(
    () => {
      textMaskHandleRef.current && textMaskHandleRef.current.update();
    },
    [textMaskHandleRef],
  );

  return updateValueForMask;
}
